import {Anchor, createTopAnchor} from '@cypro/ui/components/ui/infinite-data-table'
import {queries} from '@/shared/integrations/zero'
import {ListUsersInput} from '@cypro/engine/queries'
import {User} from '@cypro/engine/schema'
import {useQuery} from '@rocicorp/zero/react'
import {useEffect, useState} from 'react'

export function useGetUsers({
  sort = {dir: 'desc', field: 'createdAt'},
  filters,
  limit = 50,
}: Omit<Partial<ListUsersInput>, 'cursor'>) {
  const [anchor, setAnchor] = useState<Anchor<User>>(createTopAnchor<User>())

  const cursor =
    anchor.startRow?.id && anchor.startRow?.createdAt
      ? {
          id: anchor.startRow.id,
          direction: anchor.direction,
          createdAt: anchor.startRow.createdAt,
          firstName: anchor.startRow.firstName || undefined,
          lastName: anchor.startRow.lastName || undefined,
          username: anchor.startRow.username || undefined,
          name: anchor.startRow.name || undefined,
        }
      : undefined

  const query = queries.users.listUsers({
    cursor: cursor,
    limit,
    sort,
    filters: {status: ['active'] as const, ...filters},
  })

  const [users, meta] = useQuery(query)

  useEffect(() => {
    setAnchor(createTopAnchor<User>())
  }, [sort?.dir, sort?.field, filters?.groups, filters?.name, filters?.sections, filters?.wards, limit])

  return {
    anchor,
    fetchMore: setAnchor,
    query,
    users,
    meta,
    canFetchMore: users.length === limit,
    isFetching: meta.type === 'unknown',
    transformToSelectItem: (user: User) => ({label: user.name, value: user.id}),
  }
}
